/* eslint-disable no-unused-vars */
// LQC-2925 / LQC-2927 - the fixed code lists GET /ReferenceData/{list} serves. Values
// are the route segment, so the enum and the endpoint cannot drift.
export enum ReferenceList {
  DayCounts = "DayCounts",
  BusinessDayConventions = "BusinessDayConventions",
  Frequencies = "Frequencies",
  Calendars = "Calendars",
  Currencies = "Currencies",
}

// Most lists come back as plain strings; Calendars and Currencies as { code, name }.
// Strings are normalised to code = name so every list has one shape.
export interface IReferenceCode {
  code: string;
  name: string;
}

export enum ReferenceCodeField {
  code = "code",
  name = "name",
}

// Code first: typing "GBLO" should beat a name that happens to contain it.
export const REFERENCE_CODE_SEARCH_FIELDS: ReferenceCodeField[] = [
  ReferenceCodeField.code,
  ReferenceCodeField.name,
];

// What a Swap / Swaption ticket needs. Loaded on demand, never on app load.
export const SWAP_REFERENCE_LISTS: ReferenceList[] = [
  ReferenceList.DayCounts,
  ReferenceList.BusinessDayConventions,
  ReferenceList.Frequencies,
  ReferenceList.Calendars,
  ReferenceList.Currencies,
];
